import Dropzone from 'react-dropzone'

import { ICardCompany } from './types'

import { Flex, Loader, Drawer, Divider, Button, Tab } from '@ui/index'
import { IconClearClose, IconEntity, IconFiles, IconMainGrid } from '@img/icons'


/** Карточка по контрагенту */
export const CardCompany = ({
    isOpen, cardMode, companyNumber, isLoading, 
    isDisableBtnSave, tabActive, filesList, companyDateCreate, 

    getCardPage, fileUploader, 
    handleDeleteFiles, handleDownloadFiles, 
    handleBtnSave, handleBtnClose
}: ICardCompany) => {
    const getCardPageBtnPanel = (tabActive: string) => {
        switch (tabActive) {
            case 'primary': {
                return <Flex gap='4px'>
                    <Divider />
                    <Flex flexDirection='row' gap='4px' justifyContent='flex-end'>
                        <Button flexGrow={1} padding='0 10px' isDisabled={isDisableBtnSave.value || isLoading} onClick={() => handleBtnSave(true)}>Сохранить и закрыть</Button>
                        <Button flexGrow={1} padding='0 10px' isDisabled={isDisableBtnSave.value || isLoading} onClick={() => handleBtnSave(false)}>Сохранить</Button>
                    </Flex>
                </Flex>
            }

            case 'files': {
                return <Flex gap='4px'>
                    <Divider />
                    <Flex flexDirection='row' gap='4px' justifyContent='flex-end'>
                        <Flex flexDirection='row' gap='4px' isRendered={filesList.value.filter((item) => item.isSelected).length > 0}>
                            <Button padding='0 10px' variant='primaryDark' onClick={() => handleDeleteFiles()}>Удалить</Button>
                            <Button padding='0 10px' variant='primaryDark' onClick={() => handleDownloadFiles()}>Скачать</Button>
                            <Divider type='vertical' margin='8px' />
                        </Flex>

                        <Dropzone onDropAccepted={(files) => fileUploader(files)}>
                            {({ getRootProps, getInputProps }) => (
                                <div {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <Button padding={'0 10px'}>Загрузить</Button>
                                </div>
                            )}
                        </Dropzone>
                    </Flex>
                </Flex>
            }
            case 'logs': return ''
        }
    }

    return <>
        <Drawer isOpen={isOpen} placement='bottom' size='99.4%'>
            <Flex className='drawer_container'>
                <Flex flexDirection='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                    <header>
                        <Flex gap='6px' flexDirection='row' alignItems='center'>
                            <IconEntity color='#fff' width='20px' height='20px' />
                            <h4>{cardMode === 'edit' ? 'Анкета контрагента' : 'Создание контрагента'}</h4>
                        </Flex>

                        {cardMode === 'edit' && <h5>№ {companyNumber.value} от {companyDateCreate.value}</h5>}
                    </header>

                    <Button variant='icon' size='md' isDisabled={isLoading} onClick={handleBtnClose}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Flex gap='4px' className='drawer_container-body_bottom_panel'>
                    <Loader isOpen={isLoading} title='Загрузка...' backdrop />

                    <Flex gap='6px' className='drawer_container-content' overflowY={tabActive.value === 'files' ? 'hidden' : 'scroll'} padding={tabActive.value === 'files' ? '2px 0px 0px 0px' : '4px 8px 4px 4px'}>
                        {getCardPage(tabActive.value)}
                    </Flex>

                    {getCardPageBtnPanel(tabActive.value)}
                </Flex>

                <Tab.Container>
                    <Tab.Item tabName='primary' tabNameActive={tabActive.value} tabToolTipPlace='topLeft' tabToolTipTitle='Основные данные' onClick={tabActive.setValue}><IconMainGrid /></Tab.Item>
                    <Tab.Item tabName='files' tabNameActive={tabActive.value} tabToolTipPlace='topLeft' tabToolTipTitle='Файлы' onClick={tabActive.setValue}><IconFiles /></Tab.Item>
                </Tab.Container>
            </Flex>
        </Drawer>
    </>
}